<bw-action-article-legacy [brightsideWebFb]="config.analyticsAttributes()">
  <div content-section>
    <bw-spinner-legacy></bw-spinner-legacy>
  </div>
  <div footer-actions class="flex-row row-reverse"></div>
</bw-action-article-legacy>
